module.exports = __webpack_public_path__ + "static/media/FLINDERS-ALTERNATIVE.c4937e7a.gif";